import exportFromJSON from "export-from-json";
import { useRef } from "react";
import { FiUpload } from "react-icons/fi";
const ExportData = ({ exportData, fileNames }) => {
  const dRef = useRef();

  const handleExportCSV = (e) => {
    e.preventDefault();
    // console.log(exportData);
    // if (location.pathname === "/customers") {
    exportFromJSON({
      data: exportData,
      fileName: fileNames,
      exportType: exportFromJSON.types.xls,
    });
  };

  return (
    <div className="flex flex-grow-0">
      <div ref={dRef} className="flex-1">
        <button
          onClick={handleExportCSV}
          className="border flex justify-center items-center border-gray-300 hover:border-green-400 hover:text-green-400  dark:text-gray-300 cursor-pointer h-10 w-20 rounded-md focus:outline-none min-h-[50px]"
        >
          <FiUpload className="mr-2" />
          <span className="text-xs">Export</span>
        </button>
      </div>
    </div>
  );
};
export default ExportData;
